<template>
  <div class="tabs is-boxed mb-4">
    <ul>
      <li
        v-for="tab in tabs"
        :key="tab.name"
        :class="{ 'is-active': $route.name === tab.name }"
      >
        <router-link :to="{ name: tab.name }">
          <b-icon :icon="tab.icon" size="is-small" />
          <span>{{ tab.label }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SuccessionTabs",
  data() {
    return {
      tabs: [
        { name: "succession.files", label: "Dosare", icon: "folder-account" },
        {
          name: "succession.register",
          label: "Registru R.E.S.D.P.S.",
          icon: "book-open-variant",
        },
      ],
    };
  },
};
</script>
